import { TWITTER_SDK } from "@elements/ArticleParagraph/Embeds/constants";
import WrapperContainer from "@elements/ArticleParagraph/ParagraphElements/WrapperContainer";
import useScript from "@hooks/useScript/useScript";

export type XEmbedCustomProps = {
  url: string;
  className?: string;
};

export default function XEmbedCustom({
  url,
  className = "",
}: XEmbedCustomProps): React.ReactElement {
  useScript({ id: "twitter-embed-script", src: TWITTER_SDK, async: true });

  return (
    <WrapperContainer className={className}>
      <blockquote className="twitter-tweet overflow-x-auto break-words">
        <a href={url}>{url}</a>
      </blockquote>
    </WrapperContainer>
  );
}
